export const STATES = [
  {
    stateCode: 'AL',
    name: 'Alabama',
  },
  {
    stateCode: 'AK',
    name: 'Alaska',
  },
  {
    stateCode: 'AS',
    name: 'American Samoa',
  },
  {
    stateCode: 'AZ',
    name: 'Arizona',
  },
  {
    stateCode: 'AR',
    name: 'Arkansas',
  },
  {
    stateCode: 'CA',
    name: 'California',
  },
  {
    stateCode: 'CO',
    name: 'Colorado',
  },
  {
    stateCode: 'CT',
    name: 'Connecticut',
  },
  {
    stateCode: 'DE',
    name: 'Delaware',
  },
  {
    stateCode: 'DC',
    name: 'District Of Columbia',
  },
  {
    stateCode: 'FM',
    name: 'Federated States Of Micronesia',
  },
  {
    stateCode: 'FL',
    name: 'Florida',
  },
  {
    stateCode: 'GA',
    name: 'Georgia',
  },
  {
    stateCode: 'GU',
    name: 'Guam',
  },
  {
    stateCode: 'HI',
    name: 'Hawaii',
  },
  {
    stateCode: 'ID',
    name: 'Idaho',
  },
  {
    stateCode: 'IL',
    name: 'Illinois',
  },
  {
    stateCode: 'IN',
    name: 'Indiana',
  },
  {
    stateCode: 'IA',
    name: 'Iowa',
  },
  {
    stateCode: 'KS',
    name: 'Kansas',
  },
  {
    stateCode: 'KY',
    name: 'Kentucky',
  },
  {
    stateCode: 'LA',
    name: 'Louisiana',
  },
  {
    stateCode: 'ME',
    name: 'Maine',
  },
  {
    stateCode: 'MH',
    name: 'Marshall Islands',
  },
  {
    stateCode: 'MD',
    name: 'Maryland',
  },
  {
    stateCode: 'MA',
    name: 'Massachusetts',
  },
  {
    stateCode: 'MI',
    name: 'Michigan',
  },
  {
    stateCode: 'MN',
    name: 'Minnesota',
  },
  {
    stateCode: 'MS',
    name: 'Mississippi',
  },
  {
    stateCode: 'MO',
    name: 'Missouri',
  },
  {
    stateCode: 'MT',
    name: 'Montana',
  },
  {
    stateCode: 'NE',
    name: 'Nebraska',
  },
  {
    stateCode: 'NV',
    name: 'Nevada',
  },
  {
    stateCode: 'NH',
    name: 'New Hampshire',
  },
  {
    stateCode: 'NJ',
    name: 'New Jersey',
  },
  {
    stateCode: 'NM',
    name: 'New Mexico',
  },
  {
    stateCode: 'NY',
    name: 'New York',
  },
  {
    stateCode: 'NC',
    name: 'North Carolina',
  },
  {
    stateCode: 'ND',
    name: 'North Dakota',
  },
  {
    stateCode: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    stateCode: 'OH',
    name: 'Ohio',
  },
  {
    stateCode: 'OK',
    name: 'Oklahoma',
  },
  {
    stateCode: 'OR',
    name: 'Oregon',
  },
  {
    stateCode: 'PW',
    name: 'Palau',
  },
  {
    stateCode: 'PA',
    name: 'Pennsylvania',
  },
  {
    stateCode: 'PR',
    name: 'Puerto Rico',
  },
  {
    stateCode: 'RI',
    name: 'Rhode Island',
  },
  {
    stateCode: 'SC',
    name: 'South Carolina',
  },
  {
    stateCode: 'SD',
    name: 'South Dakota',
  },
  {
    stateCode: 'TN',
    name: 'Tennessee',
  },
  {
    stateCode: 'TX',
    name: 'Texas',
  },
  {
    stateCode: 'UT',
    name: 'Utah',
  },
  {
    stateCode: 'VT',
    name: 'Vermont',
  },
  {
    stateCode: 'VI',
    name: 'Virgin Islands',
  },
  {
    stateCode: 'VA',
    name: 'Virginia',
  },
  {
    stateCode: 'WA',
    name: 'Washington',
  },
  {
    stateCode: 'WV',
    name: 'West Virginia',
  },
  {
    stateCode: 'WI',
    name: 'Wisconsin',
  },
  {
    stateCode: 'WY',
    name: 'Wyoming',
  },
];
